import { useRef } from "react";
/**
 * Simple debounce function.
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/utils/debounce.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export const debounce = (cb, debounceTime = 0) => {
    let timeout;
    const dispose = () => {
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
    };
    const execute = (...args) => {
        dispose();
        timeout = setTimeout(() => {
            cb(...args);
        }, debounceTime);
    };
    return {
        /**
         *  Call handling method
         */
        execute,
        /**
         * Method of destroying handlers
         */
        dispose,
    };
};
export const useDebounce = (cb, debounceTime = 0) => {
    const timeout = useRef(null);
    const dispose = useRef(() => {
        if (timeout !== undefined) {
            clearTimeout(timeout.current);
        }
    });
    const execute = useRef((...args) => {
        dispose.current();
        timeout.current = setTimeout(() => {
            cb(...args);
        }, debounceTime);
    });
    return {
        /**
         *  Call handling method
         */
        execute: execute.current,
        /**
         * Method of destroying handlers
         */
        dispose: dispose.current,
    };
};
